import { NgModule, inject } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { routerReducer, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { MergedRouteSerializer } from 'app/utils/merged-route-serializer';
import { Router } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { RouterEffects } from 'app/effects/router';
import { routerStateConfig } from 'app/models/reducers/router';

@NgModule({
  imports: [
    StoreModule.forFeature(routerStateConfig.stateKey, routerReducer),
    StoreRouterConnectingModule.forRoot(routerStateConfig),
    EffectsModule.forFeature([RouterEffects]),
  ],
  exports: [
    StoreModule,
    StoreRouterConnectingModule,
    EffectsModule,
  ],
  providers: [
    { provide: RouterStateSerializer, useClass: MergedRouteSerializer }
  ],
})
export class NgrxRouterModule {


  constructor() {
    const router = inject(Router, { self: true, optional: true })!;

    if (!router) {
      console.error('NgrxRouterStoreModule must be imported in the same same level as RouterModule');
    }
  }
}
